import React from 'react';
import { guaranteeStats } from '../data/content';
export function StatsStrip() {
  return <section aria-label="El sistema en números" className="w-full border-b border-line bg-cream-deep" data-id="element-217" data-mp="ghf86e5g4z6l">
      <div className="mx-auto grid max-w-content grid-cols-2 divide-line px-5 lg:grid-cols-4 lg:divide-x lg:px-8" data-id="element-218" data-mp="2ifg0wiq625o">
        {guaranteeStats.map(stat => <div key={stat.label} className="py-7 text-center" data-id="element-219" data-mp="7hikofusm6d4">
            <p className="font-display text-3xl font-black text-forest" data-id="element-220" data-mp="v6baduktnhza">
              {stat.value}
            </p>
            <p className="mt-1 text-sm text-ink-muted" data-id="element-221" data-mp="104mnqfabsam9">{stat.label}</p>
          </div>)}
      </div>
    </section>;
}